import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import TroopInput from './pages/TroopInput';
import SOSInput from './pages/SOSInput';
import TabCalculation from './pages/TabCalculation';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import axios from 'axios';

// Axios Base URL konfigurieren
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://api.dstools.at';
axios.defaults.withCredentials = true;

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="min-h-screen bg-gray-50">
            <Navbar />
            <main className="container mx-auto px-4 py-8">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route 
                  path="/" 
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/troops" 
                  element={
                    <ProtectedRoute>
                      <TroopInput />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/sos" 
                  element={
                    <ProtectedRoute>
                      <SOSInput />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/tabs" 
                  element={
                    <ProtectedRoute>
                      <TabCalculation />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </main>
          </div>
        </Router>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
